export const form = document.querySelector('form#passkeys') as HTMLFormElement;
export const signupButton = form.querySelector('button#signup');
export const loginButton = form.querySelector('button#login');

export const output = document.querySelector(
    'textarea#output'
) as HTMLTextAreaElement;
